import React, {useCallback, useEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux"
import { RootReducer } from '../app/reducer';
import NewWindow from 'react-new-window';

const ExternalWindow: React.FC = props => {
    //save window for later being able to call window.focus()
    const[openWindow, setOpenWindow] = useState<Window>();
    const externalWindowContent = useSelector( (state: RootReducer) => state.appReducer.externalWindowContent )
    const rootDispatch = useDispatch()   

    useEffect(() => {        
        if(openWindow) {
            openWindow.focus();
        }        
    });

    const saveWindow = useCallback (
        (window: any) => {                        
            setOpenWindow(window);            
        },
        [],
    )

    return (
        <div id="ext-window">
        {(externalWindowContent ) && ( 
            <NewWindow onOpen={saveWindow} features={{width:900, height:500}} onUnload={()=>{rootDispatch({type:"App/EXTWINDOWCLOSE"})}}>{externalWindowContent}</NewWindow>
        )}
        </div>
    )
} 

export default ExternalWindow